import { setStarredChatsListFailed, setStarredChatsListPending, setStarredChatsListSucceed } from './actions';
import { IStarredChatsListRequest } from './types';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { fetchChatsV2, IFetchChatsV2ParamsRequest } from '../../services/chatsList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
// eslint-disable-next-line import/no-cycle
import { getQueryParamsFetchChatsList } from '../../utils/getQueryParamsFetchChatsList';
import { setRoute } from '../route';

/**
 * Получить список важных чатов
 */
export const getStarredChatsV2 =
  ({ timestampStarred }: IStarredChatsListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const {
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setStarredChatsListPending({ timestampStarred }));

    const { status, filterBy } = getQueryParamsFetchChatsList(ERoute.Starred);

    const parameters: IFetchChatsV2ParamsRequest = {
      timestamp: timestampStarred,
      subAgentRealtyUserId,
      status,
      filterBy,
    };

    const starredChats = await fetchChatsV2(context, {
      parameters,
    });

    if (starredChats === null) {
      dispatch(setStarredChatsListFailed());

      return;
    }

    dispatch(setStarredChatsListSucceed(starredChats));

    /**
     * Ставим активный пункт меню - спам и сбрасываем восстановленный id из архива,
     * чтобы обнулить открытый чат при переходе в архив.
     */
    dispatch(setRoute({ route: ERoute.Starred }));
  };
